import { useState, useRef } from 'react';
import { AppBar, Toolbar, Typography, Button, Box, Container, Drawer, IconButton, List, ListItem, ListItemText, Badge, Chip, Menu, MenuItem, Slide, Fade, Collapse, Tooltip, Divider, Link } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import BarChartIcon from '@mui/icons-material/BarChart';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import SearchIcon from '@mui/icons-material/Search';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ChatIcon from '@mui/icons-material/Chat';
import ExtensionIcon from '@mui/icons-material/Extension';
import InstagramIcon from '@mui/icons-material/Instagram';
import EmailIcon from '@mui/icons-material/Email';
import { useTheme } from '@mui/material/styles';
import { Link as RouterLink } from 'react-router-dom';
import AuthManager from './Auth/AuthManager';
import { useAuth } from '../contexts/AuthContext';

function Header() {
    const [open, setOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [mobileSubmenuOpen, setMobileSubmenuOpen] = useState(false);
    const theme = useTheme();
    const { currentUser } = useAuth();

    const toggleDrawer = (state) => () => {
        setOpen(state);
    };

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleMobileSubmenuToggle = () => {
        setMobileSubmenuOpen(!mobileSubmenuOpen);
    };

    return (
        <AppBar
            position="sticky"
            elevation={0}
            sx={{
                bgcolor: 'rgba(17, 24, 39, 0.95)',
                backdropFilter: 'blur(20px)',
                borderBottom: '1px solid rgba(76, 29, 149, 0.3)',
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)'
            }}
        >
            <Container maxWidth='auto'>
                <Toolbar
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        minHeight: { xs: '64px', sm: '70px' },
                        px: { xs: 1, sm: 2 }
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 700,
                                fontFamily: "Futura",
                                fontSize: { xs: '1.1rem', sm: '1.5rem' },
                                lineHeight: { xs: '1.3rem', sm: '1.75rem' },
                                color: 'white',
                                background: 'linear-gradient(135deg, #ffffff, #c4b5fd)',
                                backgroundClip: 'text',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                display: { xs: 'none', sm: 'block' }
                            }}
                        >
                            playLorcana.pl
                        </Typography>

                        {/* Compact mobile logo */}
                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 700,
                                fontFamily: "Futura",
                                fontSize: '1rem',
                                color: 'white',
                                background: 'linear-gradient(135deg, #ffffff, #c4b5fd)',
                                backgroundClip: 'text',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                display: { xs: 'block', sm: 'none' }
                            }}
                        >
                            playLorcana.pl
                        </Typography>

                        {/* Desktop menu */}
                        <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 1 }}>
                            <Button
                                component={RouterLink}
                                to="/"
                                color="inherit"
                                startIcon={<CalendarTodayIcon />}
                                sx={{
                                    borderRadius: '12px',
                                    px: 2,
                                    py: 1,
                                    transition: 'all 0.3s ease',
                                    '&:hover': {
                                        backgroundColor: 'rgba(76, 29, 149, 0.2)',
                                        transform: 'translateY(-1px)'
                                    }
                                }}
                            >
                                KALENDARZ
                            </Button>
                            <Button
                                color="inherit"
                                onClick={handleMenuOpen}
                                startIcon={<ExtensionIcon />}
                                sx={{
                                    borderRadius: '12px',
                                    px: 2,
                                    py: 1,
                                    transition: 'all 0.3s ease',
                                    '&:hover': {
                                        backgroundColor: 'rgba(76, 29, 149, 0.2)',
                                        transform: 'translateY(-1px)'
                                    }
                                }}
                            >
                                LIMITED
                            </Button>
                            <Menu
                                anchorEl={anchorEl}
                                open={Boolean(anchorEl)}
                                onClose={handleMenuClose}
                                PaperProps={{
                                    sx: {
                                        backgroundColor: 'rgba(17, 24, 39, 0.95)',
                                        backdropFilter: 'blur(20px)',
                                        border: '1px solid rgba(76, 29, 149, 0.3)',
                                        borderRadius: '16px',
                                        mt: 1,
                                        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)'
                                    }
                                }}
                            >
                                <MenuItem
                                    onClick={handleMenuClose}
                                    component="a"
                                    href="https://docs.google.com/document/d/1aGL_OYJA5o9xS5HHyATRMA6WgaEaXt0FpvEbf7YW2gg/edit?usp=sharing"
                                    target="_blank"
                                    sx={{
                                        color: 'white',
                                        borderRadius: '8px',
                                        mx: 1,
                                        my: 0.5,
                                        '&:hover': {
                                            backgroundColor: 'rgba(76, 29, 149, 0.3)'
                                        }
                                    }}
                                >
                                    PORADNIK
                                </MenuItem>
                                <MenuItem
                                    onClick={handleMenuClose}
                                    component={RouterLink}
                                    to="/limited"
                                    sx={{
                                        color: 'white',
                                        borderRadius: '8px',
                                        mx: 1,
                                        my: 0.5,
                                        '&:hover': {
                                            backgroundColor: 'rgba(76, 29, 149, 0.3)'
                                        }
                                    }}
                                >
                                    TIERLISTA
                                </MenuItem>
                            </Menu>
                            {currentUser && (
                                <Button
                                    component={RouterLink}
                                    to="/tracker"
                                    color="inherit"
                                    startIcon={<SportsEsportsIcon />}
                                    sx={{
                                        borderRadius: '12px',
                                        px: 2,
                                        py: 1,
                                        transition: 'all 0.3s ease',
                                        '&:hover': {
                                            backgroundColor: 'rgba(76, 29, 149, 0.2)',
                                            transform: 'translateY(-1px)'
                                        }
                                    }}
                                >
                                    TRACKER
                                </Button>
                            )}
                            {currentUser && (
                                <Button
                                    component={RouterLink}
                                    to="/scouting"
                                    color="inherit"
                                    startIcon={<SearchIcon />}
                                    sx={{
                                        borderRadius: '12px',
                                        px: 2,
                                        py: 1,
                                        transition: 'all 0.3s ease',
                                        '&:hover': {
                                            backgroundColor: 'rgba(76, 29, 149, 0.2)',
                                            transform: 'translateY(-1px)'
                                        }
                                    }}
                                >
                                    SCOUTING
                                </Button>
                            )}
                            <Box sx={{ position: 'relative' }}>
                                <Button
                                    component={RouterLink}
                                    to="/ranking"
                                    color="inherit"
                                    startIcon={<EmojiEventsIcon />}
                                    sx={{
                                        borderRadius: '12px',
                                        px: 2,
                                        py: 1,
                                        transition: 'all 0.3s ease',
                                        '&:hover': {
                                            backgroundColor: 'rgba(76, 29, 149, 0.2)',
                                            transform: 'translateY(-1px)'
                                        }
                                    }}
                                >
                                    RANKING ELO
                                    <Chip
                                        label="Soon"
                                        size="small"
                                        sx={{
                                            ml: 1,
                                            height: '20px',
                                            fontSize: '0.65rem',
                                            fontWeight: 600,
                                            background: 'linear-gradient(135deg, #7c3aed, #3b82f6)',
                                            color: 'white',
                                            border: 'none',
                                            boxShadow: '0 2px 8px rgba(124, 58, 237, 0.4)',
                                            animation: 'pulse 2s ease-in-out infinite alternate'
                                        }}
                                    />
                                </Button>
                            </Box>
                            <Button
                                color="inherit"
                                href="https://discord.gg/Sx3NyyJpqT"
                                target='_blank'
                                startIcon={<ChatIcon />}
                                sx={{
                                    borderRadius: '12px',
                                    px: 2,
                                    py: 1,
                                    background: 'linear-gradient(135deg, #5865f2, #7289da)',
                                    color: 'white',
                                    transition: 'all 0.3s ease',
                                    '&:hover': {
                                        background: 'linear-gradient(135deg, #4752c4, #5b6ecd)',
                                        transform: 'translateY(-1px)',
                                        boxShadow: '0 4px 12px rgba(88, 101, 242, 0.4)'
                                    }
                                }}
                            >
                                DISCORD
                            </Button>
                        </Box>
                    </Box>

                    {/* Right side icons */}
                    <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', gap: 1 }}>
                        <AuthManager compact={true} />
                        <Tooltip title="Obserwuj nas na Instagramie">
                            <IconButton
                                href="https://www.instagram.com/playlorcana_pl/"
                                target="_blank"
                                aria-label="Instagram"
                                sx={{
                                    color: 'rgb(196, 181, 253)',
                                    transition: 'all 0.3s ease',
                                    padding: '8px',
                                    '&:hover': {
                                        color: '#E1306C',
                                        transform: 'translateY(-2px)'
                                    },
                                }}
                            >
                                <InstagramIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    </Box>

                    {/* Mobile menu button */}
                    <IconButton
                        edge="end"
                        color="inherit"
                        sx={{
                            display: { md: 'none' },
                            background: 'linear-gradient(135deg, rgba(76, 29, 149, 0.3), rgba(139, 92, 246, 0.3))',
                            borderRadius: '12px',
                            width: '48px',
                            height: '48px',
                            backdropFilter: 'blur(10px)',
                            border: '1px solid rgba(196, 181, 253, 0.2)',
                            transition: 'all 0.3s ease',
                            '&:hover': {
                                background: 'linear-gradient(135deg, rgba(76, 29, 149, 0.5), rgba(139, 92, 246, 0.5))',
                                transform: 'scale(1.05)'
                            }
                        }}
                        onClick={toggleDrawer(true)}
                    >
                        <MenuIcon sx={{ fontSize: '1.4rem' }} />
                    </IconButton>
                </Toolbar>
            </Container>

            {/* Mobile Drawer */}
            <Drawer
                anchor="right"
                open={open}
                onClose={toggleDrawer(false)}
                PaperProps={{
                    sx: {
                        background: 'linear-gradient(180deg, rgba(17, 24, 39, 0.98) 0%, rgba(31, 41, 55, 0.98) 100%)',
                        width: '100vw',
                        backdropFilter: 'blur(20px)',
                        borderLeft: 'none',
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100vh'
                    }
                }}
                SlideProps={{
                    direction: 'left'
                }}
            >
                {/* Header w drawer */}
                <Box sx={{
                    p: 3,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    borderBottom: '1px solid rgba(76, 29, 149, 0.3)'
                }}>
                    <Typography
                        variant="h6"
                        sx={{
                            fontWeight: 700,
                            fontFamily: "Futura",
                            fontSize: '1.2rem',
                            background: 'linear-gradient(135deg, #ffffff, #c4b5fd)',
                            backgroundClip: 'text',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent'
                        }}
                    >
                        playLorcana.pl
                    </Typography>
                    <IconButton
                        onClick={toggleDrawer(false)}
                        sx={{
                            background: 'rgba(76, 29, 149, 0.2)',
                            borderRadius: '12px',
                            width: '44px',
                            height: '44px',
                            color: 'rgb(196, 181, 253)',
                            transition: 'all 0.3s ease',
                            '&:hover': {
                                background: 'rgba(76, 29, 149, 0.4)',
                                transform: 'rotate(90deg)'
                            }
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </Box>

                {/* Auth section */}
                <Box sx={{ px: 2, py: 1.5, borderBottom: '1px solid rgba(76, 29, 149, 0.3)' }}>
                    <AuthManager compact={false} />
                </Box>

                {/* Menu items */}
                <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                    <List sx={{ px: 2, py: 2, flex: 1 }}>
                        <ListItem
                            button
                            onClick={toggleDrawer(false)}
                            sx={{
                                py: 2,
                                mb: 1,
                                borderRadius: '16px',
                                background: 'rgba(76, 29, 149, 0.1)',
                                border: '1px solid rgba(76, 29, 149, 0.2)',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                    background: 'rgba(76, 29, 149, 0.3)',
                                    transform: 'translateX(8px)'
                                }
                            }}
                        >
                            <CalendarTodayIcon sx={{ mr: 2, color: 'rgb(196, 181, 253)' }} />
                            <ListItemText
                                primary="WYDARZENIA"
                                primaryTypographyProps={{
                                    sx: {
                                        color: 'white',
                                        fontWeight: '600',
                                        fontSize: '1rem'
                                    }
                                }}
                            />
                        </ListItem>

                        {/* Limited button with submenu - mobile */}
                        <Box>
                            <ListItem
                                button
                                onClick={handleMobileSubmenuToggle}
                                sx={{
                                    py: 2,
                                    mb: mobileSubmenuOpen ? 0 : 1,
                                    borderRadius: mobileSubmenuOpen ? '16px 16px 0 0' : '16px',
                                    background: 'rgba(76, 29, 149, 0.1)',
                                    border: '1px solid rgba(76, 29, 149, 0.2)',
                                    borderBottom: mobileSubmenuOpen ? 'none' : '1px solid rgba(76, 29, 149, 0.2)',
                                    transition: 'all 0.3s ease',
                                    '&:hover': {
                                        background: 'rgba(76, 29, 149, 0.3)',
                                        transform: mobileSubmenuOpen ? 'none' : 'translateX(8px)'
                                    }
                                }}
                            >
                                <ExtensionIcon sx={{ mr: 2, color: 'rgb(196, 181, 253)' }} />
                                <ListItemText
                                    primary="LIMITED"
                                    primaryTypographyProps={{
                                        sx: {
                                            color: 'white',
                                            fontWeight: '600',
                                            fontSize: '1rem'
                                        }
                                    }}
                                />
                                {mobileSubmenuOpen ?
                                    <ExpandLessIcon sx={{ color: 'rgb(196, 181, 253)' }} /> :
                                    <ExpandMoreIcon sx={{ color: 'rgb(196, 181, 253)' }} />
                                }
                            </ListItem>

                            {/* Submenu items */}
                            <Collapse in={mobileSubmenuOpen} timeout="auto" unmountOnExit>
                                <Box sx={{
                                    background: 'rgba(76, 29, 149, 0.05)',
                                    border: '1px solid rgba(76, 29, 149, 0.2)',
                                    borderTop: 'none',
                                    borderRadius: '0 0 16px 16px',
                                    mb: 1,
                                    overflow: 'hidden'
                                }}>
                                    <ListItem
                                        button
                                        component="a"
                                        href="https://docs.google.com/document/d/1aGL_OYJA5o9xS5HHyATRMA6WgaEaXt0FpvEbf7YW2gg/edit?usp=sharing"
                                        target="_blank"
                                        onClick={toggleDrawer(false)}
                                        sx={{
                                            py: 1.5,
                                            pl: 6,
                                            transition: 'all 0.3s ease',
                                            '&:hover': {
                                                background: 'rgba(76, 29, 149, 0.2)',
                                            }
                                        }}
                                    >
                                        <ListItemText
                                            primary="PORADNIK"
                                            primaryTypographyProps={{
                                                sx: {
                                                    color: 'white',
                                                    fontWeight: '500',
                                                    fontSize: '0.9rem'
                                                }
                                            }}
                                        />
                                    </ListItem>

                                    <ListItem
                                        button
                                        component={RouterLink}
                                        to="/limited"
                                        onClick={toggleDrawer(false)}
                                        sx={{
                                            py: 1.5,
                                            pl: 6,
                                            transition: 'all 0.3s ease',
                                            '&:hover': {
                                                background: 'rgba(76, 29, 149, 0.2)',
                                            }
                                        }}
                                    >
                                        <ListItemText
                                            primary="TIERLISTA"
                                            primaryTypographyProps={{
                                                sx: {
                                                    color: 'white',
                                                    fontWeight: '500',
                                                    fontSize: '0.9rem'
                                                }
                                            }}
                                        />
                                    </ListItem>
                                </Box>
                            </Collapse>
                        </Box>

                        {currentUser && (
                            <ListItem
                                button
                                component={RouterLink}
                                to="/tracker"
                                onClick={toggleDrawer(false)}
                                sx={{
                                    py: 2,
                                    mb: 1,
                                    borderRadius: '16px',
                                    background: 'rgba(76, 29, 149, 0.1)',
                                    border: '1px solid rgba(76, 29, 149, 0.2)',
                                    transition: 'all 0.3s ease',
                                    '&:hover': {
                                        background: 'rgba(76, 29, 149, 0.3)',
                                        transform: 'translateX(8px)'
                                    }
                                }}
                            >
                                <SportsEsportsIcon sx={{ mr: 2, color: 'rgb(196, 181, 253)' }} />
                                <ListItemText
                                    primary="TRACKER"
                                    primaryTypographyProps={{
                                        sx: {
                                            color: 'white',
                                            fontWeight: '600',
                                            fontSize: '1rem'
                                        }
                                    }}
                                />
                            </ListItem>
                        )}

                        {currentUser && (
                            <ListItem
                                button
                                component={RouterLink}
                                to="/scouting"
                                onClick={toggleDrawer(false)}
                                sx={{
                                    py: 2,
                                    mb: 1,
                                    borderRadius: '16px',
                                    background: 'rgba(76, 29, 149, 0.1)',
                                    border: '1px solid rgba(76, 29, 149, 0.2)',
                                    transition: 'all 0.3s ease',
                                    '&:hover': {
                                        background: 'rgba(76, 29, 149, 0.3)',
                                        transform: 'translateX(8px)'
                                    }
                                }}
                            >
                                <SearchIcon sx={{ mr: 2, color: 'rgb(196, 181, 253)' }} />
                                <ListItemText
                                    primary="SCOUTING"
                                    primaryTypographyProps={{
                                        sx: {
                                            color: 'white',
                                            fontWeight: '600',
                                            fontSize: '1rem'
                                        }
                                    }}
                                />
                            </ListItem>
                        )}

                        <ListItem
                            button
                            component={RouterLink}
                            to="/ranking"
                            onClick={toggleDrawer(false)}
                            sx={{
                                py: 2,
                                mb: 1,
                                borderRadius: '16px',
                                background: 'rgba(76, 29, 149, 0.1)',
                                border: '1px solid rgba(76, 29, 149, 0.2)',
                                transition: 'all 0.3s ease',
                                display: 'flex',
                                justifyContent: 'space-between',
                                '&:hover': {
                                    background: 'rgba(76, 29, 149, 0.3)',
                                    transform: 'translateX(8px)'
                                }
                            }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <EmojiEventsIcon sx={{ mr: 2, color: 'rgb(196, 181, 253)' }} />
                                <ListItemText
                                    primary="RANKING ELO"
                                    primaryTypographyProps={{
                                        sx: {
                                            color: 'white',
                                            fontWeight: '600',
                                            fontSize: '1rem'
                                        }
                                    }}
                                />
                            </Box>
                            <Chip
                                label="Soon"
                                size="small"
                                sx={{
                                    height: '24px',
                                    fontSize: '0.7rem',
                                    fontWeight: 600,
                                    background: 'linear-gradient(135deg, #7c3aed, #3b82f6)',
                                    color: 'white',
                                    border: 'none',
                                    boxShadow: '0 2px 8px rgba(124, 58, 237, 0.4)',
                                    animation: 'pulse 2s ease-in-out infinite alternate'
                                }}
                            />
                        </ListItem>

                        <ListItem
                            button
                            component="a"
                            href="https://discord.gg/Sx3NyyJpqT"
                            target="_blank"
                            onClick={toggleDrawer(false)}
                            sx={{
                                py: 2,
                                borderRadius: '16px',
                                background: 'linear-gradient(135deg, rgba(88, 101, 242, 0.2), rgba(114, 137, 218, 0.2))',
                                border: '1px solid rgba(88, 101, 242, 0.3)',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                    background: 'linear-gradient(135deg, rgba(88, 101, 242, 0.4), rgba(114, 137, 218, 0.4))',
                                    transform: 'translateX(8px)'
                                }
                            }}
                        >
                            <ChatIcon sx={{ mr: 2, color: 'rgb(196, 181, 253)' }} />
                            <ListItemText
                                primary="DISCORD"
                                primaryTypographyProps={{
                                    sx: {
                                        color: 'white',
                                        fontWeight: '600',
                                        fontSize: '1rem'
                                    }
                                }}
                            />
                        </ListItem>
                    </List>
                </Box>

                {/* Footer w drawer */}
                <Box sx={{
                    p: 2,
                    borderTop: '1px solid rgba(76, 29, 149, 0.3)',
                    mt: 'auto'
                }}>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 2,
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: 2,
                            }}
                        >
                            <Tooltip title="Dołącz do naszego Discorda">
                                <IconButton
                                    href="https://discord.gg/Sx3NyyJpqT"
                                    target="_blank"
                                    sx={{
                                        color: 'rgb(196, 181, 253)',
                                        transition: 'all 0.3s ease',
                                        padding: '8px',
                                        '&:hover': {
                                            color: '#5865F2',
                                            transform: 'translateY(-2px)'
                                        },
                                    }}
                                >
                                    <ChatIcon fontSize="small" />
                                </IconButton>
                            </Tooltip>

                            <Divider orientation="vertical" flexItem sx={{ borderColor: 'rgba(76, 29, 149, 0.3)' }} />

                            <Tooltip title="Obserwuj nas na Instagramie">
                                <IconButton
                                    href="https://www.instagram.com/playlorcana_pl/"
                                    target="_blank"
                                    aria-label="Instagram"
                                    sx={{
                                        color: 'rgb(196, 181, 253)',
                                        transition: 'all 0.3s ease',
                                        padding: '8px',
                                        '&:hover': {
                                            color: '#E1306C',
                                            transform: 'translateY(-2px)'
                                        },
                                    }}
                                >
                                    <InstagramIcon fontSize="small" />
                                </IconButton>
                            </Tooltip>

                            <Divider orientation="vertical" flexItem sx={{ borderColor: 'rgba(76, 29, 149, 0.3)' }} />

                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    color: 'rgb(196, 181, 253)',
                                }}
                            >
                                <EmailIcon fontSize="small" sx={{ mr: 0.5 }} />
                                <Link
                                    href="mailto:contact@playlorcana.pl"
                                    sx={{
                                        color: 'rgb(196, 181, 253)',
                                        textDecoration: 'none',
                                        '&:hover': {
                                            textDecoration: 'underline',
                                            color: 'white',
                                        },
                                        transition: 'color 0.2s',
                                        fontSize: '0.875rem',
                                    }}
                                >
                                    contact@playlorcana.pl
                                </Link>
                            </Box>
                        </Box>

                        <Typography
                            variant="caption"
                            sx={{
                                color: 'rgb(156, 163, 175)',
                                fontSize: '0.8rem',
                                textAlign: 'center'
                            }}
                        >
                            © {new Date().getFullYear()} playLorcana.pl
                        </Typography>
                    </Box>
                </Box>
            </Drawer>

            <style jsx global>{`
                @keyframes pulse {
                    0% {
                        box-shadow: 0 2px 8px rgba(124, 58, 237, 0.4);
                    }
                    100% {
                        box-shadow: 0 4px 16px rgba(124, 58, 237, 0.8);
                    }
                }
            `}</style>
        </AppBar>
    );
}

export default Header;